module.exports = __webpack_public_path__ + "img/112.5e33934c.jpg";